export default __webpack_public_path__ + "static/media/uniOfRaj.c05c14a6.jpg";